module.exports = __webpack_public_path__ + "static/img/fksq.0dea466c.png";